export const ElementQuery = {
  all: '全て',
  exic: 'EX-ICのみ',
  air_seat_number_empty: '座席が空欄'
} as const;

export type ElementQueryKey = keyof typeof ElementQuery;

export const ElementQueryKeys: readonly ElementQueryKey[] = ['all', 'exic', 'air_seat_number_empty'];
